import { Injectable } from '@angular/core';
import { AppPaymentTVService } from './app-payment-tv.service';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API, COUNTRIES_LIST } from '../constants';
import { API as AWS_API } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  paystandCss = `${environment.CONSUMER_PORTAL}assets/custom-css/paystand.css`;
  // paypalCurrencies = ['USD', 'GBP', 'EUR', 'AUD', 'BRL', 'CAD', 'CZK', 'DKK', 'HKD', 'HUF',
  //   'JPY', 'MYR', 'MXN', 'NOK', 'NZD', 'PHP', 'PLN', 'RUB', 'SGD', 'SEK', 'CHF', 'TWD', 'THB', 'TRY'];
  paypalCurrencies = []; // disabled paypal
  constructor(private appPaymentService: AppPaymentTVService) { }

  calculateTax(data, callback) {
    //console.log(data);
    let country = COUNTRIES_LIST.filter(con => con.alpha3code == data.address.country_code);
    country = country[0] ? country[0] : {};
    var tran = 0, serv = 0, tran_add_on = 0, serv_add_on = 0;
    if (data.paymentType == 'pay_per_view' || data.payment_type == 'pay_per_view' || data.paymentType == 'channel_subscription' || data.payment_type == 'order') {
      tran = 14;
      serv = 679;
      tran_add_on = 14;
      serv_add_on = 15;
      if (data.address.country_code == 'USA' || data.address.country_code == 'CAN') {
        tran = 57;
        // tran_add_on = 10;
        if (!data.vod) {
          serv = 674;
        } else {
          serv = 675;
          if (data.vod_video_audio == 'audio') {
            serv = 661;
          }
        }
      }
    }
    let taxInclCountries = ["GBR"], taxInclCurreencies = ["GBP", "EUR"];
    let time = (new Date()).getTime();
    //console.log(data.address.country_code, data.currency);
    data.invoice_id = 'INV' + time.toString() + this.randomString(2);
    if (taxInclCountries.indexOf(data.address.country_code) != -1 && taxInclCurreencies.indexOf(data.currency) != -1) {
      data.incl = true;
    }
    let country_code = data.address.country_code;
    let shipping_country_code = data.address.shipping_country_code;
    let state_code = data.address.state_code;
    let city = data.address.city;
    let zip = data.address.zip;
    let shippingZip = data.address.shippingZip;
    if (country.validation != 'yes') {
      city = '';
      state_code = '';
    }
    if (country_code == 'HKG') {
      country_code = 'CHN';
      state_code = 'HK';
    }
    let payload = {
      "cmpn": {
        "bscl": 1,
        "svcl": 1,
        "fclt": false,
        "frch": false,
        "reg": true
      },
      "inv": []
    };
    if (data.amount) {
      let stream = {
        "doc": data.invoice_id,
        "cmmt": false,
        "bill": {
          //   "int": true,							
          //   "geo": true,
          //   "pcd": 0,
          //   "npa": 0,
          //   "fips": "string",
          //   "addr": data.address.line1,
          // "cnty": data.address.country,
          "ctry": country_code,
          "st": state_code,
          "city": city,
          "zip": zip
        },
        "cust": 1,
        // "lfln": true,
        "date": new Date(),
        "itms": [
          {
            "ref": data.stream_id,
            "chg": data.amount,
            // "line": 0,
            // "loc": 0,
            // "min": 0,
            "sale": 1,			//--Sale:  Sale Type:						
            "incl": data.incl,
            "tran": tran,			//--Transaction Type:		
            "serv": serv,			//--Service Type: 			
            // "dbt": true,
            // "adj": false,
            // "adjm": 0,
            // "disc": 0,
            // "prop": 0
          }
        ],
        "invm": true,
        "dtl": false,
        "summ": true,
        "ccycd": data.currency
      };
      payload.inv.push(stream);
    }
    if (data.addOnAmount) {
      let code = shipping_country_code ? shipping_country_code : country_code;
      if (code == 'USA' || code == 'CAN') {
        tran_add_on = 10;
      }
      let add_on =
      {
        "doc": data.invoice_id,
        "cmmt": false,
        "bill": {
          //   "int": true,							
          //   "geo": true,
          //   "pcd": 0,
          //   "npa": 0,
          //   "fips": "string",
          //   "addr": data.address.line1,
          // "cnty": data.address.country,
          "ctry": shipping_country_code? shipping_country_code : country_code,
          "st": state_code,
          "city": city,
          "zip": shippingZip ? shippingZip : zip
        },
        "cust": 1,
        // "lfln": true,
        "date": new Date(),
        "itms": [
          {
            "ref": data.stream_id,
            "chg": data.addOnAmount,
            // "line": 0,
            // "loc": 0,
            // "min": 0,
            "sale": 1,			//--Sale:  Sale Type:						
            "incl": data.incl,
            "tran": tran_add_on,			//--Transaction Type:		
            "serv": serv_add_on,			//--Service Type: 			
            // "dbt": true,
            // "adj": false,
            // "adjm": 0,
            // "disc": 0,
            // "prop": 0
          }
        ],
        "invm": true,
        "dtl": false,
        "summ": true,
        "ccycd": data.currency
      }
      payload.inv.push(add_on);
    }
    if (data.liveAmount) {
      let live =
      {
        "doc": data.invoice_id,
        "cmmt": false,
        "bill": {
          //   "int": true,							
          //   "geo": true,
          //   "pcd": 0,
          //   "npa": 0,
          //   "fips": "string",
          //   "addr": data.address.line1,
          // "cnty": data.address.country,
          "ctry": data.venueAddress.country_code,
          "st": data.venueAddress.state_code,
          "city": data.venueAddress.city,
          "zip": data.venueAddress.zip
        },
        "cust": 1,
        // "lfln": true,
        "date": new Date(),
        "itms": [
          {
            "ref": data.stream_id,
            "chg": data.liveAmount,
            // "line": 0,
            // "loc": 0,
            // "min": 0,
            "sale": 1,			//--Sale:  Sale Type:						
            "incl": data.incl,
            "tran": 3,			//--Transaction Type:		
            "serv": 687,			//--Service Type: 			
            // "dbt": true,
            // "adj": false,
            // "adjm": 0,
            // "disc": 0,
            // "prop": 0
          }
        ],
        "invm": true,
        "dtl": false,
        "summ": true,
        "ccycd": data.currency
      }
      payload.inv.push(live);
    }
    let reqData = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${data.access_token}`
      },
      response: true,
      body: payload
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_TAX, reqData).then(response => {
    let taxData = response['data'];
    // this.appPaymentService.postUrlRequest("/api/v2/afc/calctaxes", payload).subscribe(taxData => {
      let result = {
        status: 0, data: {
          amount: data.amount, finalAmount: data.amount,
          invoice_id: data.invoice_id, tax: 0, incl: data.incl, taxPercentage: 0
        }, taxData: taxData
      }
      var finalAmount = parseFloat(data.amount), taxAmount = 0;
      if (taxData && !taxData.err && taxData.inv) {
        taxData.inv.forEach(element => {
          if (element.summ) {
            element.summ.forEach((tax) => {
              taxAmount += tax.tax;
              result.data.taxPercentage += tax.rate;
            });
          }
        });
        if (data.currency.toLowerCase() == 'jpy') {
          finalAmount = parseFloat(finalAmount.toFixed(0));
          taxAmount = parseFloat(taxAmount.toFixed(0))
        }
        if (!data.incl) {
          finalAmount = finalAmount;
          finalAmount += taxAmount;
        }
        // if (taxData.inv[0].summ) {
        //   taxData.inv[0].summ.forEach((tax) => {
        //     taxAmount += tax.tax;
        //     result.data.taxPercentage += tax.rate;
        //   });
        //   if (data.currency.toLowerCase() == 'jpy') {
        //     finalAmount = parseFloat(finalAmount.toFixed(0));
        //     taxAmount = parseFloat(taxAmount.toFixed(0))
        //   }
        //   if (!data.incl) {
        //     finalAmount = finalAmount;
        //     finalAmount += taxAmount;
        //   }
        // }
      } else {
        result.status = 1;
      }
      result.data.finalAmount = finalAmount;
      result.data.tax = taxAmount;

      if (data.currency.toLowerCase() == 'gbp' && data.address.country_code == "GBR") {
        // if (this.currency && this.currency.toLowerCase() == 'gbp') {
        result.data.taxPercentage = 0.05;
        result.data.tax = data.amount * (1 - (1 / (1 + result.data.taxPercentage)));
        result.data.tax = parseFloat(result.data.tax.toFixed(2));
        result.data.finalAmount = data.amount;
        result.data.invoice_id = '';
        result.data.incl = true;
      }
      //console.log(result);
      callback(result);
    });
  }

  randomString(n) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    n = n || 6;
    for (var i = 0; i < n; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  addPaypalScript(currency) {
    return new Promise((resolve) => {
      let status = false;
      if (this.paypalCurrencies.indexOf(currency) != -1) {
        let element = document.createElement('script');
        element.src = 'https://www.paypal.com/sdk/js?client-id=' + environment.paypal.client_id + '&intent=authorize&currency=' + currency;
        element.onload = resolve;
        document.body.appendChild(element);
        status = true;
      }
      resolve(status);
    });
  }

  getSubscriptionStatus(userInfo, streamData, callback: (val: any) => void) {
    let subscriptionStatus = false;
    if (!userInfo || Object.keys(userInfo).length == 0) {
      callback(subscriptionStatus);
    } else {

      let reqData = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${userInfo.access_token}`
        },
        response: true,
        body: {
          user_id: userInfo.id,
          channel_url: streamData.channel_name
        }
      }
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_SUBSCRIPTION_STATUS, reqData).then(response => {
        if (response.data.message === "Success") {
          if (response.data && response.data.Data && response.data.Data.length > 0) {
            if (response.data.Data[0].subscription_status == 0) {
              if (new Date().getTime() < new Date(response.data.Data[0].subscription_end_date).getTime()) {
                subscriptionStatus = true;
              } else {
                subscriptionStatus = false;
              }
            } else {
              subscriptionStatus = true;
            }
          } else {
            subscriptionStatus = false;
          }
          callback(subscriptionStatus);
        } else {
          subscriptionStatus = false;
          callback(subscriptionStatus);
        }
      }).catch(error => {
        callback(subscriptionStatus);
      });
    }
  }

  getSubscriptionAmount(amounts, country, currency) {
    let amount;
    let defaultAmount;
    amounts.forEach(element => {
      if (element.country_name == 'DEFAULT') {
        defaultAmount = element.payment_amount;
      }
      if (element.country_name == country && element.currency_type == currency) {
        amount = element.payment_amount;
      }

    });
    amount = amount || defaultAmount;
    return amount;
  }
}
